module.exports = __webpack_public_path__ + "img/vpc2.8f9b567.png";